module.exports = __webpack_public_path__ + "static/img/aepic-24.da6adbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-24.jpg
// module id = Ndpp
// module chunks = 52